/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberCircleNine(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M148,112a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,112Zm84,16A104,104,0,1,1,128,24,104.11791,104.11791,0,0,1,232,128Zm-68-16a36,36,0,1,0-36,36q.91626,0,1.82129-.04639l-16.68945,27.94385a8.00015,8.00015,0,1,0,13.73632,8.20508l32.249-53.99512c.09668-.16162.178-.32812.262-.49365A35.76587,35.76587,0,0,0,164,112Z" />
    </Svg>
  );
}

export default NumberCircleNine;
